export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Thin.df2989a8.woff2";